/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// function showDiv(){
//   var kmk1 = document.querySelector('.customsize');
//   kmk1.style.display = 'block';
// }

$( ".custom-size" ).on( "click", function(e) {
  e.preventDefault();
  $('.customsize').show();
  $('.clear-custom-size').show();
  $('[value="Custom Size"]').click();
});

$('.clear-custom-size').on( "click", function(){
  $(this).hide();
  $('.customsize').hide();
  $('.customsize .Form__Input').val('');
  $('.SizeSwatchList .HorizontalList__Item:nth-child(1) .SizeSwatch__Radio').click();
});
$('.ProductForm__Variants .SizeSwatch__Radio:not([value="Custom Size"])+label').on( "click", function(){
  $('.clear-custom-size').hide();
  $('.customsize').hide();
  $('.customsize .Form__Input').val('');
});
